'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _angular = require('angular');

var _angular2 = _interopRequireDefault(_angular);

var _language = require('./language.factory');

var _language2 = _interopRequireDefault(_language);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var languageModule = _angular2.default.module('language.factory', []).factory('LanguageFactory', _language2.default).name;

exports.default = languageModule;


// WEBPACK FOOTER //
// ./client/app/common/factories/languageFactory/language.js